/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconRotate = createReactComponent("outline", "rotate", "IconRotate", [["path", { "d": "M19.95 11a8 8 0 1 0 -.5 4m.5 5v-5h-5", "key": "svg-0" }]]);

export { IconRotate as default };
//# sourceMappingURL=IconRotate.mjs.map
